// Estilos da aba "Inteligentes" da tela de config da Central de Alertas.
// Um Paper só com uma LINHA por detecção, no mesmo idioma da aba Exibição:
// conteúdo à esquerda (ícone da categoria + nome + descrição + regra em
// vigor) e controles à direita (MetricInfo, lápis de ajustes e switch com
// rótulo de estado). Linha desativada tem o CONTEÚDO esmaecido; os controles
// ficam em opacidade cheia de propósito, para seguirem legíveis.

const styles = (theme) => ({
	container: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		p: "16px",
		borderRadius: "16px",
		backgroundColor: theme.palette.background.paper,
	},
	intro: {
		color: theme.palette.text.secondary,
		maxWidth: "900px",
	},
	divisorTopo: {
		mt: 1,
	},
	linha: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: 2,
		py: 1.75,
		px: 1,
		borderRadius: 2,
		transition: "background-color 120ms",
		"&:hover": { bgcolor: "action.hover" },
	},
	// Só o conteúdo esmaece quando a detecção está inativa (ver cabeçalho).
	conteudo: (ativo) => ({
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		gap: "12px",
		flexGrow: 1,
		minWidth: 0,
		opacity: ativo ? 1 : 0.45,
	}),
	// Ícone da categoria na cor semântica dela (corCategoriaInteligente).
	iconeCategoria: (cor) => ({
		color: cor,
		fontSize: 20,
		mt: "2px",
		flexShrink: 0,
	}),
	textos: {
		display: "flex",
		flexDirection: "column",
		gap: "2px",
		minWidth: 0,
	},
	nome: {
		fontWeight: 500,
	},
	legenda: {
		color: theme.palette.text.secondary,
		display: "block",
	},
	// Regra em vigor: pares rótulo/valor separados por ponto médio.
	linhaRegra: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		alignItems: "baseline",
		gap: "6px",
		mt: "4px",
	},
	rotuloRegra: {
		color: theme.palette.text.secondary,
	},
	valorRegra: {
		fontWeight: 600,
	},
	nota: {
		color: theme.palette.text.secondary,
		fontStyle: "italic",
		display: "block",
	},
	controles: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: "4px",
		flexShrink: 0,
	},
	// Reserva o lugar do lápis nas categorias sem parâmetros, para os switches
	// das três linhas ficarem alinhados.
	espacoLapis: {
		width: 30,
		height: 30,
	},
	blocoSwitch: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: "2px",
		minWidth: 64,
	},
	estado: (ativo) => ({
		color: ativo ? theme.palette.text.primary : theme.palette.text.secondary,
	}),
	observacao: {
		color: theme.palette.text.secondary,
	},
});

export default styles;
